/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

const unformatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';
  
  let cleaned = phoneNumber.replace(/[\s\-().]/g, '');
  
  if (cleaned.startsWith('+33')) {
    cleaned = '0' + cleaned.substring(3);
  }
  
  if (cleaned.startsWith('0033')) {
    cleaned = '0' + cleaned.substring(4);
  }

  cleaned = cleaned.replace(/\D/g, '');
  
  if (cleaned.length !== 10) {
    return phoneNumber;
  }
  
  const formatted = cleaned.match(/.{1,2}/g);
  
  return formatted ? formatted.join(' ') : phoneNumber;
};

export default unformatPhoneNumber;
